module.exports = __webpack_public_path__ + "static/image2.f0c55a6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project1/image2.jpg
// module id = 130
// module chunks = 100667300852966 131627143932366